export default "__VITE_ASSET__i10oVt1z__"